import React from 'react';

import type { IToolbarItem } from './../../../ricos-types';
import { Decoration_Type, Node_Type } from './../../../ricos-types';

import {
  AlignmentButton,
  FontSizeButton,
  HeadingButtonSwitch,
  HighlightColorButton,
  LineSpacingButton,
  LinkButton,
  TextColorButton,
  TitleButton,
  ToggleButton,
} from '../../components/buttons';

type ToolbarRenderer = (toolbarItem: IToolbarItem) => React.ReactElement;

const toggleRenderers = [
  'UNDO',
  'REDO',
  Decoration_Type.BOLD,
  Decoration_Type.ITALIC,
  Decoration_Type.UNDERLINE,
  Node_Type.BLOCKQUOTE,
  Node_Type.CODE_BLOCK,
  Node_Type.ORDERED_LIST,
  Node_Type.BULLETED_LIST,
  Decoration_Type.SPOILER,
  `INDENT.increase`,
  `INDENT.decrease`,
].reduce<Record<string, ToolbarRenderer>>((acc, t) => {
  return {
    ...acc,
    [t]: toolbarItem => {
      return (
        <ToggleButton
          onClick={(e: React.MouseEvent) => toolbarItem.commands?.click(e)}
          toolbarItem={toolbarItem}
        />
      );
    },
  };
}, {});

export const formattingItemsRenderers: Record<
  string,
  (toolbarItem: IToolbarItem) => React.ReactElement
> = {
  ...toggleRenderers,
  'TextAlignment.ALIGNMENT': toolbarItem => {
    return <AlignmentButton toolbarItem={toolbarItem} />;
  },
  [`${Node_Type.HEADING}.title`]: toolbarItem => {
    return <TitleButton toolbarItem={toolbarItem} />;
  },
  [`${Node_Type.HEADING}.dropdown`]: toolbarItem => {
    return <HeadingButtonSwitch toolbarItem={toolbarItem} />;
  },
  LINE_SPACING: toolbarItem => {
    return <LineSpacingButton toolbarItem={toolbarItem} />;
  },
  [Decoration_Type.FONT_SIZE]: toolbarItem => {
    return <FontSizeButton toolbarItem={toolbarItem} />;
  },
  [Decoration_Type.LINK]: toolbarItem => {
    return <LinkButton toolbarItem={toolbarItem} />;
  },
  [`${Decoration_Type.COLOR}.foreground`]: toolbarItem => {
    return <TextColorButton toolbarItem={toolbarItem} />;
  },
  [`${Decoration_Type.COLOR}.background`]: toolbarItem => {
    return <HighlightColorButton toolbarItem={toolbarItem} />;
  },
};
